import { useEffect, useState } from 'react';
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { getOpsGenieScheduleFeatureState } from '../../services/opsgenie-schedule-feature';
import { setFeatureState } from './actions';
import { type State, type FeatureState, opsgenieScheduleFeatureStates } from './types';

const actions = {
	setFeatureState,
} as const;

type Actions = typeof actions;

const initialState: State = {
	state: opsgenieScheduleFeatureStates.LOADING,
};

// @Export for testing
export const Store = createStore<State, Actions>({
	name: 'opsgenieSchedulePageFeatureStateStore',
	initialState,
	actions,
});

const useOpsGenieScheduleFeatureHook = createHook(Store);

export const useOpsGenieScheduleFeatureState = (
	projectId: string | number,
	isProjectSimplified: boolean,
): FeatureState => {
	const [featureState, featureActions] = useOpsGenieScheduleFeatureHook();
	const [error, setError] = useState<unknown>(undefined);
	if (error) {
		setError(undefined);
		throw error;
	}
	useEffect(() => {
		const fetchData = async () => {
			try {
				await getOpsGenieScheduleFeatureState(projectId, isProjectSimplified).then((value) =>
					featureActions.setFeatureState(value.value),
				);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (thrownError: any) {
				setError(thrownError);
			}
		};
		// We need to check projectId because of the default state
		if (typeof projectId === 'string' || projectId > 0) {
			fetchData();
		} else {
			featureActions.setFeatureState(false);
		}
	}, [featureActions, projectId, isProjectSimplified]);

	return featureState.state;
};
